module.exports = __webpack_public_path__ + "img/cooking_logo.482b572e.svg";